export default __webpack_public_path__ + "static/media/NH09.b747eb0f.jpg";